<template>
  <div class="featured-dorms__list dorm-card__list user__list-wrp istatistik">
    <container class="gen-container">
      <DormDashboardHead
        :first-name="first_name"
        :last-name="last_name"
        :logo="dormLogo"
        :mail="mail1"
      ></DormDashboardHead>
      <div class="user__list-offer">
        <DormRoomList :rooms="rooms" @delete="deleteRoom"></DormRoomList>
      </div>
    </container>
  </div>
</template>

<script>
import DormDashboardHead from '@/components/Dorm/DormDashboardHead.vue'
import DormRoomList from '@/features/Room/DormRoomList.vue'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'DormRoomListView',
  components: { DormRoomList, DormDashboardHead },
  metaInfo() {
    return {
      title: 'Odalarım'
    }
  },
  data() {
    return {
      dormLogo: null,
      mail: '',
      rooms: []
    }
  },
  computed: {
    ...mapGetters(['first_name', 'last_name', 'phone', 'mail1'])
  },
  methods: {
    async getDormRooms() {
      this.dormLogo = window.localStorage.getItem('cache:dorm_logo')
      const res = await axios.get('/dorm/rooms').catch(() => ({ data: [] }))
      this.rooms = res.data.data
    },
    deleteRoom(id) {
      this.rooms = this.rooms.filter(room => room.id !== id)
    }
  },
  mounted() {
    this.mail = window.localStorage.getItem('mail')
    this.username = window.localStorage.getItem('username')
  },
  created() {
    this.getDormRooms()
  }
}
</script>
